export default __webpack_public_path__ + "static/live-image-desktop-6244ce840badefc8e13dacd60a0932d4.webp";